import React from 'react';
import { Divider } from 'antd';
import Context from '../Container/Context';

const useJudgementHomepage = () => {
  const { history } = React.useContext(Context);
  const [isHomepage, setIsHomepage] = React.useState(() => {
    const { pathname } = history.location;
    return pathname === '/' || pathname.includes('/home');
  });

  React.useEffect(() => {
    const unlisten = history.listen((location) => {
      const { pathname } = location;
      const isHome = pathname === '/' || pathname.includes('/home');
      setIsHomepage(isHome);
    });
    return () => {
      unlisten();
    };
  });

  return isHomepage;
};

export default () => {
  const isHomepage = useJudgementHomepage();

  if (isHomepage) return null;

  return <Divider className="header-divider menu-record" />;
};
